import React from 'react'
import { Spinner } from '@components/atoms'

import { useAppDispatch, authActions } from '@redux/index'

const AuthLoadingPage = () => {
	// redux dispatch
	const reduxDispatch = useAppDispatch()

	React.useEffect(() => {
		reduxDispatch(authActions.TRIGGER_AUTH_LOADING_PAGE(true))
	}, [])

	return <Spinner />
}

export default AuthLoadingPage
